(function() {
    'use strict';

    angular.module('remitEventsApp').service('PaginationService', function() {
        this.getPages = function(currentPage, totalElements, totalPages) {
            var pages = [];

            if (totalElements > 0) {
                var i = 1;

                if (totalPages < 8) {
                    for (i = 1; i <= totalPages; i++) {
                        pages.push(i);
                    }
                } else if (currentPage <= 5) {
                    for (i = 1; i <= 7; i++) {
                        pages.push(i);
                    }
                    if (i < totalPages) {
                        pages.push(0);
                    }
                    pages.push(totalPages);
                } else if (currentPage > 5 && currentPage + 3 < totalPages) {
                    pages.push(1);
                    pages.push(0);
                    for (i = currentPage - 3; i <= currentPage + 3; i++) {
                        pages.push(i);
                    }
                    if (i < totalPages) {
                        pages.push(0);
                    }
                    pages.push(totalPages);
                } else {
                    var j = totalPages - currentPage;
                    var k = 6 - j;

                    pages.push(1);
                    pages.push(0);

                    for (i = currentPage - k; i <= totalPages; i++) {
                        pages.push(i);
                    }
                }
            } else {
                pages.push(1);
            }

            return pages;
        };
    });
})();
